export const adminSections = [
  {
    path: "dashboard",
    name: "Inicio",
    description: "La actividad de tu negocio, de un vistazo.",
  },
  {
    path: "salesChannel",
    name: "Canal de venta",
    description: "Configura dónde y cómo recibes tus pedidos.",
  },
  {
    path: "orders",
    name: "Pedidos",
    description: "Consulta el estado y los detalles de cada pedido.",
  },
  {
    path: "carts",
    name: "Carritos",
    description: "Consulta los carritos que todavía no han generado un pedido.",
  },
  {
    path: "products",
    name: "Productos",
    description: "Organiza tu carta, sus precios y cómo la ven tus clientes.",
  },
  {
    path: "catalogs",
    name: "Catálogos",
    description: "Elige qué productos se ofrecen en cada carta.",
  },
  {
    path: "categories",
    name: "Categorías",
    description: "Agrupa tus productos para que sea más fácil encontrarlos.",
  },
  {
    path: "attributes",
    name: "Atributos",
    description: "Organiza los extras y opciones de tus productos.",
  },
  {
    path: "clients",
    name: "Clientes",
    description: "Consulta la información de tus clientes.",
  },
  {
    path: "discounts",
    name: "Descuentos",
    description: "Crea promociones y controla cuándo se pueden utilizar.",
  },
  {
    path: "help",
    name: "Ayuda",
    description: "Guías rápidas para trabajar con tu negocio.",
  },
  {
    path: "configuration",
    name: "Configuración",
    description: "Ajustes del negocio, la tienda, tu equipo y los pagos.",
  },
];
